module.exports = __webpack_public_path__ + "img/func_4_2.747c92d3.svg";